import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useEboxConfiguration } from '../configuration/useEboxConfiguration';
import { queryKeys } from '../queryKeys';

import { fetchSunsetAsset } from './fetchSunsetAsset';

type UseEboxSunsetConfigurationProps = {
  imageRatio: '2x3' | '16x9';
};

export function useEboxSunsetConfiguration({ imageRatio }: UseEboxSunsetConfigurationProps) {
  const configuration = useEboxConfiguration();

  const isEnabled = Boolean(configuration && configuration.isServerTerminated && configuration.sunsetAssetId);

  const {
    data: asset,
    error,
    isLoading,
  } = useQuery({
    queryKey: isEnabled ? ['EBOX'] : queryKeys.disabled,
    queryFn: () => fetchSunsetAsset({ id: configuration!.sunsetAssetId! }),
    enabled: isEnabled,
    staleTime: 0,
  });

  const sunsetConfiguration = useMemo(() => {
    const image = asset?.images.find((i) => i.ratio === imageRatio);

    return {
      image,
      qrCodeUrl: configuration?.qrCodeUrl,
    };
  }, [asset, configuration?.qrCodeUrl, imageRatio]);

  return {
    configuration: sunsetConfiguration,
    error,
    isLoading,
  };
}
